import { render, staticRenderFns } from "./HDPdfViewer.vue?vue&type=template&id=36e208f5&scoped=true&"
import script from "./HDPdfViewer.vue?vue&type=script&lang=js&"
export * from "./HDPdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./HDPdfViewer.vue?vue&type=style&index=0&id=36e208f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e208f5",
  null
  
)

export default component.exports